import { Routes } from '@angular/router';
import { AcademyComponent } from 'src/app/academy/academy.component';
import { AccessGroupComponent } from 'src/app/access-group/access-group.component';
import { DashboardComponent } from 'src/app/dashboard/dashboard.component';
import { EventComponent } from 'src/app/event/event.component';
import { KnowledgeBaseComponent } from 'src/app/knowledge-base/knowledge-base.component';
import { ResourceDetailComponent } from 'src/app/resource-detail/resource-detail.component';
import { ResourceComponent } from 'src/app/resource/resource.component';
import {LoginGuard} from "src/app/login.guard"
import { MessageComponent } from 'src/app/message/message.component';
import { UserPanelComponent } from 'src/app/user-panel/user-panel.component';
import { NewsletterComponent } from 'src/app/newsletter/newsletter.component';
import { NotificationComponent } from 'src/app/notification/notification.component';
export const CommonLayout_ROUTES: Routes = [
    // {
    //     path: 'dashboard',
    //     loadChildren: () => import('../../dashboard/dashboard.module').then(m => m.DashboardModule),
    // },
    {
        path: 'dashboard',
        component: DashboardComponent,
    },
    {
        path: 'resources',
        data: {
            title: 'Resources'
        },
        component: ResourceComponent,

    },
    {
        path: 'resources/:id',
        data: {
            title: 'Resource Detail'
        },
        component: ResourceDetailComponent
    },
    {
        path: 'groups',
        data: {
            title: 'Access Groups'
        },
        component: AccessGroupComponent
    },
    // {
    //     path: 'events',
    //     data: {
    //         title: 'Events'
    //     },
    //     component: EventComponent
    // },
    {
        path: 'knowledge-base',
        data: {
            title: 'Knowledge Base'
        },
        component: KnowledgeBaseComponent
    },
    {
        path: 'academy',
        data: {
            title: 'Academy'
        },
        component: AcademyComponent
    },
    {
        path: 'message',
        data: {
            title: 'Message'
        },
        component: MessageComponent
    },
    {
        path: 'notification',
        data: {
            title: 'Notifications'
        },
        component: NotificationComponent
    },
    {
        path: 'newsletter',
        data: {
            title: 'Newsletter'
        },
        component: NewsletterComponent
    },
    {
        path: 'user-panel',
        data: {
            title: 'User Panel'
        },  
        component: UserPanelComponent,
    }
    // {
    //     path: 'resources',
    //     component: ResourceComponent,
    //     data: { title: 'Resources' },
    //     children: [
    //       {
    //         path: '',
    //         pathMatch: 'full',
    //         redirectTo: ''
    //       },
    //       {
    //         path: ':id',
    //         component: ResourceDetailComponent,
    //         data: { title: 'Resource Detail' }
    //       }
    //     ]
    //   }
      
      
];